(() => {
  // Respect users who prefer reduced motion
  const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (mq.matches) return;

  // Create an overlay canvas
  const c = document.createElement('canvas');
  c.id = 'snow-overlay';
  Object.assign(c.style, {
    position: 'fixed',
    inset: '0',
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    zIndex: '2147483647' // above everything, but still non-interactive
  });
  document.documentElement.appendChild(c);

  const ctx = c.getContext('2d');
  let w, h, flakes = [], frameId;

  const isMobile = /Mobi|Android/i.test(navigator.userAgent);
  const MAX_FLAKES = isMobile ? 60 : 140;   // density
  const WIND_BASE = 0.15;                   // horizontal drift
  const WIND_VARIANCE = 0.35;
  const GRAVITY_MIN = 0.35;
  const GRAVITY_MAX = 1.15;
  const SIZE_MIN = 1.0;
  const SIZE_MAX = 3.2;

  function resize() {
    w = c.width = window.innerWidth;
    h = c.height = window.innerHeight;
  }
  window.addEventListener('resize', resize, { passive: true });
  resize();

  function rand(a, b) { return a + Math.random() * (b - a); }

  function newFlake(x = Math.random() * w, y = rand(-h, 0)) {
    return {
      x, y,
      r: rand(SIZE_MIN, SIZE_MAX),
      velY: rand(GRAVITY_MIN, GRAVITY_MAX),
      wind: rand(WIND_BASE - WIND_VARIANCE, WIND_BASE + WIND_VARIANCE),
      phase: Math.random() * Math.PI * 2, // for gentle sway
      opacity: rand(0.55, 0.95)
    };
  }

  function populate() {
    flakes.length = 0;
    for (let i = 0; i < MAX_FLAKES; i++) flakes.push(newFlake(Math.random() * w, Math.random() * h));
  }
  populate();

  // Low-FPS safeguard: if we’re chugging, auto-thin flakes
  let last = performance.now(), fpsSamples = [];
  function trackFPS(now) {
    const dt = now - last; last = now;
    const fps = 1000 / dt;
    fpsSamples.push(fps);
    if (fpsSamples.length > 30) fpsSamples.shift();
    const avg = fpsSamples.reduce((a, b) => a + b, 0) / fpsSamples.length;
    if (avg < 30 && flakes.length > 50) flakes.splice(0, 10); // lighten load
  }

  function draw(now) {
    trackFPS(now);
    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = '#ffffff';

    for (let f of flakes) {
      // gentle horizontal sinusoidal sway
      f.phase += 0.01;
      f.x += f.wind + Math.sin(f.phase) * 0.3;
      f.y += f.velY;

      // wrap around
      if (f.y > h + 5) { f.y = -10; f.x = Math.random() * w; }
      if (f.x > w + 5) f.x = -5;
      if (f.x < -5) f.x = w + 5;

      ctx.globalAlpha = f.opacity;
      ctx.beginPath();
      ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.globalAlpha = 1;
    frameId = requestAnimationFrame(draw);
  }
  frameId = requestAnimationFrame(draw);

  // Public toggle via custom event if you ever need it:
  window.addEventListener('snow:stop', () => { cancelAnimationFrame(frameId); c.remove(); }, { once: true });
})();
